import React from "react";
import { motion } from "framer-motion";
import { Hand, Warehouse, Truck, Check, AlertTriangle } from "lucide-react";
import { useLang } from "../../i18n";
import { contexts, pitfalls } from "../../data/safety";

const icons = { Hand, Warehouse, Truck };

export default function ContextGuide() {
  const { t, lang } = useLang();
  return (
    <div>
      <p className="text-sm text-wachs-dim leading-relaxed max-w-2xl">{t.safety.context.intro}</p>

      {/* Top pitfalls */}
      <div className="mt-6 rounded-lg border border-sonne/40 bg-sonne/10 p-5" data-testid="context-pitfalls">
        <div className="flex items-center gap-2 text-sonne"><AlertTriangle size={18} /><span className="instrument-label">{t.safety.context.pitfallsTitle}</span></div>
        <ul className="mt-3 grid gap-x-6 gap-y-2 md:grid-cols-2">
          {pitfalls.map((p) => (
            <li key={p.de} className="flex items-start gap-2 text-sm text-wachs-dim">
              <span className="text-sonne mt-1">✕</span>
              <span>{lang === "de" ? p.de : p.en}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Contexts */}
      <div className="mt-6 grid gap-4 md:grid-cols-3">
        {contexts.map((c, i) => {
          const Icon = icons[c.icon] || Hand;
          const tips = lang === "de" ? c.tipsDe : c.tipsEn;
          const pf = lang === "de" ? c.pitfallsDe : c.pitfallsEn;
          return (
            <motion.div
              key={c.id}
              data-testid={`context-${c.id}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.06 }}
              className="grid-panel rounded-lg overflow-hidden"
            >
              <div className="flex items-center gap-2.5 px-4 py-3 border-b border-bronze/15 bg-tiefsee-2/40">
                <Icon size={18} className="text-sonne" />
                <span className="font-mono text-sm tracking-wide">{lang === "de" ? c.de : c.en}</span>
              </div>
              <div className="p-4">
                <p className="instrument-label text-ready/90 mb-2">{t.safety.context.tips}</p>
                <ul className="space-y-2">
                  {tips.map((tip) => (
                    <li key={tip} className="flex items-start gap-2 text-sm text-wachs-dim">
                      <Check size={15} className="text-ready shrink-0 mt-0.5" /> <span>{tip}</span>
                    </li>
                  ))}
                </ul>
                <p className="instrument-label text-sonne mt-4 mb-2">{t.safety.context.pitfalls}</p>
                <ul className="space-y-2">
                  {pf.map((x) => (
                    <li key={x} className="flex items-start gap-2 text-sm text-wachs-dim">
                      <AlertTriangle size={14} className="text-sonne shrink-0 mt-0.5" /> <span>{x}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
